import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import useDeviceType from "../../../global/Hooks/useDeviceType";

function ChartRenderer({ data, mode }) {
  const chartFormatter = new Intl.NumberFormat("fa-IR");
  // mode: "count" | "area"
  const deviceType = useDeviceType();
  const [barSize, setBarSize] = useState(30);

  useEffect(() => {
    if (deviceType === "mobile") setBarSize(10);
  }, [deviceType]);

  // 🔹 curved bar corners (top-left, top-right, bottom-right, bottom-left)
  const barRadius = [2, 2, 0, 0];

  return (
    <Box sx={{ width: "100%", height: "22rem" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          barSize={barSize}
          style={{ fontSize: "11px" }}
          margin={{
            top: 2,
            right: mode === "area" ? 10 : 0,
            left: deviceType === "mobile" ? -40 : -20,
            bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="3 2" />

          <XAxis
            dataKey="name"
            angle={-30}
            tickMargin={12}
            tickFormatter={(name) =>
              name.length > 12 ? `${name.slice(0, 12)}...` : name
            }
          />

          <YAxis
            tickMargin={deviceType === "mobile" ? 12 : 30}
            fontSize="13px"
            tickFormatter={(value) => chartFormatter.format(value)}
          />

          <Tooltip
            cursor={false}
            content={({ active, payload }) => {
              if (active && payload?.length) {
                const d = payload[0].payload;
                return (
                  <div
                    style={{
                      background: "#fff",
                      padding: 10,
                      border: "1px solid #ccc",
                      borderRadius: 8,
                    }}
                  >
                    <Typography color="#3592FB">
                      سفارش جدید: {chartFormatter.format(d.value)}
                    </Typography>
                    <Typography color="rgba(154, 64, 224, 1)">
                      خرابی: {chartFormatter.format(d.value1)}
                    </Typography>
                    <Typography color="rgba(76, 175, 80, 1)">
                      تجدید ساخت: {chartFormatter.format(d.value2)}
                    </Typography>
                    <Typography color="rgba(255, 152, 0, 1)">
                      اصلاحیه: {chartFormatter.format(d.value3)}
                    </Typography>
                    <Typography color="#ff0000ab">
                      جمع کل: {chartFormatter.format(d.value4)}
                    </Typography>
                  </div>
                );
              }
              return null;
            }}
          />

          {/* 🔹 Curved stacked bars */}
          <Bar dataKey="value" stackId="a" fill="#3592FB" radius={barRadius} />
          <Bar
            dataKey="value1"
            stackId="a"
            fill="rgba(154, 64, 224, 1)"
            radius={barRadius}
          />
          <Bar
            dataKey="value2"
            stackId="a"
            fill="rgba(76, 175, 80, 1)"
            radius={barRadius}
          />
          <Bar
            dataKey="value3"
            stackId="a"
            fill="rgba(255, 152, 0, 1)"
            radius={barRadius}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default ChartRenderer;
